import React, { Component } from "react";
import {Card,CardBody,CardGroup,Col,Container,Input,InputGroup,InputGroupAddon,InputGroupText,Row} from "reactstrap";
import { Auth, Storage } from "aws-amplify";
import LoaderButton from "../../../containers/DefaultLayout/LoaderButton";
import BackgroundImage from "../../../components/BackgroundImage";
import Loading from "../../../components/Loading";
import LogoImg from '../../../assets/img/logo_dark.png'
import { getOrganizationGroup } from "../../../apis/OrganizationGroupsApis";
import { noAuthApi } from "../../../apis/api";
import { getUserOrgs, getLoggedUserData, updateUser } from "../../../apis/UserApis";
import OtpInput from 'react-otp-input';
import OtpTimer from 'otp-timer';
import styles from './login.module.scss';
class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      password: "",
      profile_pic: "../../assets/img/avatars/user.png",
      user:"",
      otp:"",
      loginForm:true,
      orgLogo: LogoImg,
      congnitoUser: null,
      invalidOtp: false,
      invalidCredentials: false
    };
  }
  componentDidMount = async () => {
    this.setState({
      loadingStatus: true
    });
    let res = await noAuthApi('/noAuth/getMasterData');
    this.setState({
      loadingStatus: false
    });
    if (res["data"]["orgLogo"]){
      this.setState({
        orgLogo: res["data"]["orgLogo"]
      })
    }
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({
      isLoading: true,
      loadingStatus: true
    });
    try {
      const user = await Auth.signIn(this.state.email, this.state.password);
      if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {
        this.setState({
          congnitoUser: user,
          loginForm: false,
          isLoading: false,
          loadingStatus: false
        })
      } else {
        this.getLoggedUserData();
      }      
    } catch (e) {
      console.log(e);
      this.setState({ isLoading: false });
      if (e.code === "UserNotConfirmedException") {
        this.doUserVerification();
      } else {
        this.setState({
          isLoading: false,
          loadingStatus: false,
          invalidCredentials: true
        });
      }
    }
  };
  
  handleOTP = async event => {
    event.preventDefault();
    this.setState({ isLoading: true, invalidOtp: false });    
    try {
      await Auth.confirmSignIn(
        this.state.congnitoUser,
        this.state.otp
      );
      this.getLoggedUserData();
    } catch (e) {
      console.log(e);
      this.setState({ isLoading: false, invalidOtp: true });
    }
  }
  doUserVerification() {
    var code = prompt("Please enter verification code");
    if (code !== "") {
      try {
        Auth.confirmSignUp(this.state.email, code, {
          // Optional. Force user confirmation irrespective of existing alias. By default set to True.
          forceAliasCreation: true
        })
          .then(async data => {
            // console.log(data);
            console.log(data);
            await Auth.signIn(this.state.email, this.state.password);
            const userData = await Auth.currentAuthenticatedUser({
              bypassCache: true // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
            });
            let userUpdatedData = {
              "isActive": true
            }
            await updateUser(userData.attributes["sub"],userUpdatedData);
            this.getLoggedUserData();
          })
          .catch(err => {
            console.log(err);
            alert(err.message);
            this.doUserVerification();
          });
      } catch (e) {
        alert(e.message);
      }
    }
  }

  async getLoggedUserData() {
    const userData = await Auth.currentAuthenticatedUser({
      bypassCache: true // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    });
    const userInfo = await getLoggedUserData(userData.attributes["sub"]);
    if(userInfo["statusCode"] === 0) {
      this.setState({
        isLoading: false
      });
    } else {
      this.pageRedirection(userInfo["data"])
    }
  }

  pageRedirection = async(userInfo) => {
    if (userInfo["userProfile"] === "S") {
      localStorage.setItem("orgName", "Global");
      localStorage.setItem("orgId", "global");
      localStorage.setItem('orgLog', userInfo["logoPath"])
      localStorage.setItem('orgLogId', userInfo["orgLogId"])
      localStorage.setItem('backgroundImage', userInfo["appBackgroundImage"])
      localStorage.setItem('backgroundImageId', userInfo["appBackgroundImageId"])
    } else if (userInfo["userProfile"] === "R") {
      let user = await getOrganizationGroup(userInfo["orgId"]);
      const userOrgs = user["data"];
      localStorage.setItem("orgName", userOrgs["groupName"]);
      localStorage.setItem("orgId", userOrgs["id"]);
    } else {
      let user = await getUserOrgs(userInfo["id"]);
      const userOrgs = user["data"];
      // console.log(userOrgs);
      localStorage.setItem("orgName", userOrgs[0]["orgName"]);
      localStorage.setItem("orgId", userOrgs[0]["id"]);
    }
    localStorage.setItem("login", true);
    localStorage.setItem("userName", userInfo["firstName"] + " " + userInfo["lastName"]);
    localStorage.setItem("userProfile", userInfo["userProfile"]);
    localStorage.setItem("email", userInfo["email"]);
    localStorage.setItem("userId", userInfo["id"]);
    localStorage.setItem("restaurantId", userInfo["restaurantId"]);
    localStorage.setItem("UserDetails", JSON.stringify(userInfo));
    if (userInfo["picture"] && userInfo["picture"] !== "NULL") {
      this.setState({
        profile_pic: await Storage.get(userInfo["picture"])
      });
    }
    localStorage.setItem("profile_pic", this.state.profile_pic);
    this.props.history.push("/home");
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <BackgroundImage />
        <Container>
          <Row className="justify-content-center">
            <Col md="5">
              <CardGroup>
                <Card className="p-4">
                  {this.state.loginForm ? <CardBody>
                    <img src={this.state.orgLogo} alt="VIF logo" style={{display: "block", margin:"auto", width:"120px", height:"120px", marginTop:"-100px", marginBottom:"40px", border: "2px solid white", padding:"10px", background:"#FFF", borderRadius:"5px"}} />
                    <form onSubmit={this.handleSubmit}>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="Username"
                          id="email"
                          value={this.state.email}
                          onChange={this.handleChange}
                          required
                        />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="password"
                          placeholder="Password"
                          id="password"
                          value={this.state.password}
                          onChange={this.handleChange}
                          required
                        />
                      </InputGroup>
                      <p style={{textAlign: "center"}}>
                      {this.state.invalidCredentials
                        && (
                          <small className={styles.error}>
                            <span className={styles.invalid_credentials} >Please enter valid Credentials. </span>
                          </small>
                      )}
                      </p>
                      <Row style={{marginTop:"60px"}}>
                        <Col xs="6">
                          <LoaderButton
                            block
                            bssize="large"
                            // disabled={!this.validateForm()}
                            type="submit"
                            isLoading={this.state.isLoading}
                            text="Login"
                            loadingText=" Logging in…"
                            style={{background:"#258ea5", color:"white", }}
                          />
                          {/*<input type="Submit" color="primary" className="px-4 primary" value="Login" />*/}
                        </Col>
                        <Col xs="6" className="text-right">
                          <a href="/forgot_password" style={{color:"#35ae57", fontWeight:"bold"}}>Forgot password?</a>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                  : 
                    <CardBody className={styles.login_form}>                      
                      <form onSubmit={this.handleOTP}>
                        <img src={this.state.orgLogo} alt="VIF logo" style={{display: "block", margin:"auto", width:"120px", height:"120px", marginTop:"-100px", marginBottom:"40px", border: "2px solid white", padding:"10px", background:"#FFF", borderRadius:"5px"}} />
                        <h5>Please enter the verification code sent to you by Text/SMS message</h5>                      
                        <OtpInput
                          isInputNum
                          containerStyle="otp-Outline"
                          value={this.state.otp}
                          onChange={e => {this.setState({otp:e})}}
                          numInputs={6}
                          isDisabled={false}
                          className={styles.input_btn_style}
                          inputStyle={styles.otp_input}                            
                          renderInput={(props) => <input {...props} required/>}
                        />
                        <div className={styles.resend}>
                          <OtpTimer seconds={90} minutes={0} textColor="red" buttonColor="red" background="#fff" ButtonText="Resend OTP" />
                        </div>
                        <p style={{textAlign: "center"}}>
                      {this.state.invalidOtp
                        && (
                          <small className={styles.error}>
                            <span>Please enter valid OTP </span>
                          </small>
                        )}</p>
                      <Row style={{marginTop:"60px"}}>
                        <Col xs="12">
                          <LoaderButton
                            block
                            bssize="large"
                            // disabled={!this.validateForm()}
                            type="submit"
                            isLoading={this.state.isLoading}
                            text="Login"
                            loadingText=" Logging in…"
                            style={{background:"#258ea5", color:"white", }}
                          />
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                  }
                </Card> 
              
              </CardGroup>
            </Col>
          </Row>
          <Loading loadingStatus={this.state.loadingStatus} />
        </Container>
      </div>
    );
  }
}

export default Login;